import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SvgIconModule } from 'shared/components/svg-icon/svg-icon.module';
import { NanorepService } from '../nanorep-panel/nanorep.service';
import { SmartAdvisorComponent } from './smart-advisor.component';
import { SmartAdvisorService } from 'shared/components/smart-advisor/smart-advisor.service';
import { SmartAdvisorLoaderService } from 'shared/components/smart-advisor/smart-advisor-loader.service';
import { UserPermissionService } from 'shared/services/user-permissions/user-permission.service';
import { NotificationBarService } from 'shared/services/notification/notification-bar.service';
import { BcConfigService } from 'common/config/provider';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    SvgIconModule
  ],
  providers: [
    NanorepService,
    SmartAdvisorService,
    SmartAdvisorLoaderService,
    UserPermissionService,
    NotificationBarService,
    BcConfigService
  ],
  declarations: [
    SmartAdvisorComponent
  ],
  exports: [
    SmartAdvisorComponent
  ]
})
export class SmartAdvisorModule {}
